const SIGNED_URL_PARAMS = ['Expires', 'Signature', 'Key-Pair-Id'];

export function isSignedMediaUrl(url: string): boolean {
  try {
    const {searchParams} = new URL(url);
    return SIGNED_URL_PARAMS.some(param => searchParams.has(param));
  } catch {
    return false;
  }
}
